// extracted by mini-css-extract-plugin
module.exports = {"root":"LogoWrapper_root__1tRC2","img_wrapper":"LogoWrapper_img_wrapper__1OUXw"};